import { IsOptional, IsNotEmpty, IsString, MaxLength, MinLength, IsArray, IsBoolean, IsInt } from 'class-validator';

export class AbilityPricelistEditDTO {

   @IsNotEmpty()
   @IsString()
   @MaxLength(50)
   name: string;

   @IsOptional()
   @IsString()
   description: string;

   @IsNotEmpty()
   @IsString()
   @MinLength(3)
   @MaxLength(3)
   currency: string;

   @IsNotEmpty()
   @IsBoolean()
   defaultForCurrency: boolean;

   @IsNotEmpty()
   @IsInt()
   monthly: number;

   @IsNotEmpty()
   @IsInt()
   yearly: number;

   @IsNotEmpty()
   @IsInt()
   appNotifications: number;

   @IsNotEmpty()
   @IsInt()
   emailNotifications: number;

   @IsNotEmpty()
   @IsInt()
   smsNotifications: number;

   @IsNotEmpty()
   @IsInt()
   storage: number;

   @IsNotEmpty()
   @IsInt()
   phoneSupport: number;

   @IsOptional()
   @IsArray()
   @IsString({
      each: true
   })
   @MinLength(36, {
      each: true
   })
   @MaxLength(36, {
      each: true
   })
   tenants: Array<string>;

}
